import { createGlobalStyle } from 'styled-components';

const GlobalStyle = createGlobalStyle`
  /* @font-face 선언은 public/index.html 인라인 <style>에 있음.
     (여기 두면 JS 번들이 파싱된 뒤에야 폰트 로드가 시작돼 첫 화면이 늦어짐)
     'Pretendard Variable' = 서브셋(494KB) 1순위, 'Pretendard Full' = 원본 전체(2MB) 폴백.
     서브셋에 없는 희귀 글자가 나올 때만 브라우저가 원본을 내려받는다. */

  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  html, body, #root {
    width: 100%;
    height: 100%;
    font-family: 'Pretendard Variable', 'Pretendard Full', Pretendard, -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Malgun Gothic', sans-serif;
    overflow: hidden;
  }

  button {
    cursor: pointer;
    border: none;
    outline: none;
    font-family: inherit;
  }

  input, select, textarea {
    font-family: inherit;
    outline: none;
  }

  @keyframes blink {
    0%, 100% { opacity: 1; }
    50% { opacity: 0.3; }
  }

  ::-webkit-scrollbar-button {
    display: none;
    width: 0;
    height: 0;
  }

  @media print {
    @page {
      size: A4;
      margin: 0 5mm;
    }
    html, body, #root {
      overflow: visible !important;
      height: auto !important;
      background: #fff !important;
    }
    /* 인쇄 시 [data-print-area] 외 다른 모든 요소 숨김 — 부모 팝업/카드/배경 등이 인쇄에 같이 안 나오도록 */
    body * {
      visibility: hidden !important;
      box-shadow: none !important;
    }
    [data-print-area],
    [data-print-area] * {
      visibility: visible !important;
    }
    /* 인쇄 전용 컨테이너(data-print-area) — fixed는 첫 페이지만 출력되므로 static.
       부모 클리핑은 컴포넌트가 beforeprint에서 <body> 직속으로 분리해 해소. */
    [data-print-area] {
      position: static !important;
      width: 100% !important;
      height: auto !important;
      max-width: none !important;
      max-height: none !important;
      transform: none !important;
      padding: 0 !important;
      margin: 0 !important;
      overflow: visible !important;
      background: #fff !important;
      box-shadow: none !important;
      border-radius: 0 !important;
    }
    [data-print-area] * {
      max-width: 100% !important;
      box-shadow: none !important;
    }
    [data-print-hide] {
      display: none !important;
    }
    /* 인쇄 시 placeholder 숨김 (수기 작성용 빈 폼) */
    [data-print-area] input::placeholder,
    [data-print-area] textarea::placeholder {
      color: transparent !important;
      opacity: 0 !important;
    }
  }
`;

export default GlobalStyle;
